<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/vue/24/outline'
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const faqs = computed(() => [
  {
    question: t('landingPage.v2.faq.items[0].question'),
    answer: t('landingPage.v2.faq.items[0].answer'),
  },
  {
    question: t('landingPage.v2.faq.items[1].question'),
    answer: t('landingPage.v2.faq.items[1].answer'),
  },
  {
    question: t('landingPage.v2.faq.items[2].question'),
    answer: t('landingPage.v2.faq.items[2].answer'),
  },
  {
    question: t('landingPage.v2.faq.items[3].question'),
    answer: t('landingPage.v2.faq.items[3].answer'),
  },
  {
    question: t('landingPage.v2.faq.items[4].question'),
    answer: t('landingPage.v2.faq.items[4].answer'),
  },
  {
    question: t('landingPage.v2.faq.items[5].question'),
    answer: t('landingPage.v2.faq.items[5].answer'),
  },
  {
    question: t('landingPage.v2.faq.items[6].question'),
    answer: t('landingPage.v2.faq.items[6].answer'),
  },
  {
    question: t('landingPage.v2.faq.items[7].question'),
    answer: t('landingPage.v2.faq.items[7].answer'),
  },
  {
    question: t('landingPage.v2.faq.items[8].question'),
    answer: t('landingPage.v2.faq.items[8].answer'),
  },
  {
    question: t('landingPage.v2.faq.items[9].question'),
    answer: t('landingPage.v2.faq.items[9].answer'),
  },
  {
    question: t('landingPage.v2.faq.items[10].question'),
    answer: t('landingPage.v2.faq.items[10].answer'),
  },
  {
    question: t('landingPage.v2.faq.items[11].question'),
    answer: t('landingPage.v2.faq.items[11].answer'),
  },
]);
</script>

<template>
  <div class="py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="mx-auto max-w-5xl divide-y divide-white/10">
        <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl text-center mb-16"
          v-html="$t('landingPage.v2.faq.header')">
        </h2>
        <dl class="mt-10 space-y-6 divide-y divide-white/10">
          <Disclosure as="div" v-for="faq in faqs" :key="faq.question" class="pt-6" v-slot="{ open }">
            <dt>
              <DisclosureButton class="flex w-full items-start justify-between text-left text-white">
                <span class="text-md font-semibold">{{ faq.question }}</span>
                <span class="ml-6 flex h-7 items-center">
                  <PlusSmallIcon v-if="!open" class="size-6 text-terciary" aria-hidden="true" />
                  <MinusSmallIcon v-else class="size-6 text-terciary" aria-hidden="true" />
                </span>
              </DisclosureButton>
            </dt>
            <transition enter-active-class="transition-all duration-300 ease-out overflow-hidden"
              enter-from-class="transform opacity-0 max-h-0" enter-to-class="transform opacity-100 max-h-96"
              leave-active-class="transition-all duration-300 ease-in overflow-hidden"
              leave-from-class="transform opacity-100 max-h-96" leave-to-class="transform opacity-0 max-h-0">
              <DisclosurePanel as="dd" class="mt-2 pr-12">
                <div class="text-md text-gray-400 space-y-2" v-html="faq.answer"></div>
              </DisclosurePanel>
            </transition>
          </Disclosure>
        </dl>
      </div>
    </div>
  </div>
</template>

<style scoped></style>